var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _g, _path13, _path14, _rect, _rect2, _circle, _path15, _circle2, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _g2, _path38, _circle3, _path39, _path40, _path41, _rect3, _rect4, _circle4, _path42, _circle5, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _ellipse, _circle6, _circle7, _path51, _path52, _path53, _g3, _path54, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstTimePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 594,
    height: 599,
    viewBox: "0 0 594 599",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.2945 256.18L42.7047 248.433C47.7107 244.313 60.2424 247.464 60.2424 247.464L63.2312 234.552L49.1376 232.082L42.1089 228.672L32.0703 254.876L33.2945 256.18Z",
    fill: "#FFAE64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6372 250.151L24.1111 258.862C23.9126 259.995 24.3308 261.148 25.2095 261.891C26.5369 263.012 28.5154 262.89 29.7136 261.631C31.1619 260.11 33.3059 257.895 36.0094 255.206C41.287 249.957 44.5378 247.984 44.5378 247.984C44.5378 247.984 43.0411 244.091 43.9671 238.806C44.8931 233.52 49.2627 231.381 49.2627 231.381C43.9906 228.12 37.6953 226.933 31.5977 228.051L30.941 228.171L28.4461 238.265L29.5468 240.274L27.3988 244.701C26.5613 246.427 25.9684 248.261 25.6372 250.151Z",
    fill: "#2C2770"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4098 342.769L27.8193 331.248C26.9732 325.119 35.8007 316.511 35.8007 316.511L26.8005 307.625L17.7469 317.844L11.4609 321.852L27.738 343.112L29.4098 342.769Z",
    fill: "#FFAE64"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6805 345.976L26.9965 351.571C27.8181 352.299 28.9645 352.536 30.0073 352.193C31.5823 351.675 32.4722 350.006 32.0486 348.403C31.5365 346.465 30.8082 343.616 29.9747 340.073C28.3475 333.16 28.3698 329.532 28.3698 329.532C28.3698 329.532 24.457 328.802 20.6247 325.406C16.7925 322.011 17.2384 317.391 17.2384 317.391C11.9521 320.045 7.83985 324.567 5.6993 330.081L5.46875 330.675L12.4251 337.75L14.6079 337.86L17.1316 341.819C18.1157 343.363 19.3102 344.762 20.6805 345.976Z",
    fill: "#2C2770"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0088 328.747L16.4609 311.674L75.5556 242.759L79.0682 175.238C79.3847 169.154 81.1821 163.239 84.3038 158.008L96.5102 137.555L138.842 164.457L157.462 199.858L166.063 218.734C170.968 229.5 161.514 241.259 149.945 238.779L114.887 205.981L107.266 251.639C106.889 253.895 105.833 255.981 104.237 257.62L35.0088 328.747Z",
    fill: "url(#paint0_linear_2770_43146)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.4082 225.475L137.185 215.508L155.731 239.172L47.9453 252.657L51.4082 225.475Z",
    fill: "url(#paint1_linear_2770_43146)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9996 185.195L82.6324 246.179L22.0234 316.141",
    stroke: "white",
    strokeWidth: 0.748261
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M115.926 199.789L136.129 220.366L111.062 223.733",
    stroke: "white",
    strokeWidth: 0.748261
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5781 231.22L76.6447 228.227",
    stroke: "white",
    strokeWidth: 0.748261
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M100.143 70.8169L116.114 70.4375L149.302 78.3092C157.699 80.3011 166.457 80.1873 174.8 77.9777L177.893 77.1584L179.901 103.739L154.407 113.745L148.443 125.462L147.284 158.486C146.998 166.63 139.235 172.409 131.351 170.346L86.7676 158.68C83.7642 157.893 81.86 154.942 82.3826 151.881L89.2316 111.773L81.4955 120.727L63.2578 112.023L76.7879 85.5045C81.2847 76.6907 90.2515 71.0518 100.143 70.8169Z",
    fill: "#FFE071"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M117.005 67.1366C119.183 64.0448 121.589 52.8875 122.519 47.6953C128.519 50.321 139.794 57.4758 136.905 65.0901C134.015 72.7044 136.427 75.3518 137.994 75.7237C138.826 79.8301 138.081 87.9226 128.442 87.4414C118.805 86.9596 113.007 77.0137 111.312 72.1013C112.302 71.7347 114.827 70.2284 117.005 67.1366Z",
    fill: "#FF9330"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M107.998 56.7202C109.144 62.832 115.727 63.1613 121.34 59.7567L129.751 56.0161C132.635 54.7329 137.736 48.0816 139.927 44.9164C142.343 42.2586 144.262 43.1745 145.998 36.1101C147.734 29.0457 143.1 20.9743 136.337 18.7201C129.574 16.4658 128.608 20.9743 118.625 19.6862C110.958 18.6968 106.387 21.9404 106.388 29.9913C106.388 35.6215 98.5425 36.2112 100.591 44.9164C101.879 50.3907 107.032 51.5677 107.998 56.7202Z",
    fill: "url(#paint2_linear_2770_43146)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.057 66.5721C119.316 63.5932 122.052 52.6582 123.138 47.5625C129.011 50.3602 139.982 57.8107 136.875 65.2312C133.768 72.6509 136.08 75.3477 137.625 75.7682C138.322 79.8515 137.328 87.8174 127.776 87.0131C118.223 86.2079 112.778 76.1895 111.25 71.2801C112.244 70.9524 114.798 69.5509 117.057 66.5721Z",
    fill: "url(#paint3_linear_2770_43146)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2770_43146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 111,
    y: 47,
    width: 27,
    height: 41
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.057 66.5721C119.316 63.5932 122.052 52.6582 123.138 47.5625C129.011 50.3602 139.982 57.8107 136.875 65.2312C133.768 72.6509 136.08 75.3477 137.625 75.7682C138.322 79.8515 137.328 87.8174 127.776 87.0131C118.223 86.2079 112.778 76.1895 111.25 71.2801C112.244 70.9524 114.798 69.5509 117.057 66.5721Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2770_43146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.947 72.5579C121.45 64.327 124.132 53.3814 126.659 48.9375L135.2 66.4176C137.739 71.8941 140.443 80.7887 130.947 72.5579Z",
    fill: "#D76767"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.768 61.1489C121.462 65.6609 130.378 71.2699 140.005 66.5087C145.626 63.7297 144.161 56.5419 142.413 48.6836C141.167 43.0814 140.698 36.7294 138.367 33.25L128.495 34.2901C130.382 35.3653 133.802 36.7167 129.88 38.4609C125.999 40.1871 121.764 40.6346 119.792 40.0749C121.14 45.2199 117.433 46.3902 118.499 48.7884L121.521 55.5819C118.525 57.2976 116.615 54.4131 116.036 52.7564C114.373 52.5379 111.509 53.1418 113.358 57.2984C115.206 61.4542 118.402 61.5971 119.768 61.1489Z",
    fill: "url(#paint4_linear_2770_43146)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M132.609 57.8281L137.947 58.0698C137.912 58.8323 137.275 60.0864 135.556 60.2532C133.837 60.4201 132.968 58.9139 132.609 57.8281Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5.46116,
    height: 2.04793,
    rx: 1.02397,
    transform: "matrix(-0.913706 0.406376 0.406376 0.913706 140.195 38.7656)",
    fill: "#2C2770"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 5.46116,
    height: 2.04793,
    rx: 1.02397,
    transform: "matrix(-0.913706 0.406376 0.406376 0.913706 127.719 44.3125)",
    fill: "#2C2770"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.02397,
    cy: 1.02397,
    r: 1.02397,
    transform: "matrix(-0.913706 0.406376 0.406376 0.913706 127.859 47.9844)",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M133.266 43.3438L138.259 54.5714L135.452 55.8195",
    stroke: "black",
    strokeWidth: 0.748261
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.02397,
    cy: 1.02397,
    r: 1.02397,
    transform: "matrix(-0.913706 0.406376 0.406376 0.913706 139.711 42.7188)",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M81.948 121.162L62.8524 111.899L77.1341 84.9273C81.852 76.017 91.0409 70.3759 101.121 70.2008L111.364 70.0234L123.291 85.829C125.344 87.7363 129.254 94.3127 128.464 105.359C127.476 119.166 119.134 178.269 108.635 186.855C101.279 192.871 80.3922 182.775 64.8201 177.843C62.3863 177.072 61.6807 173.698 63.5701 171.981C84.2512 153.188 86.7967 128.053 88.6375 112.81L81.948 121.162Z",
    fill: "url(#paint5_linear_2770_43146)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.161 30.9678L218.527 9.35518C218.69 6.77623 218.591 5.94932 220.368 4.07269L223.951 0.287308C224.42 -0.208265 225.247 -0.0371382 225.481 0.604047C226.188 2.54264 225.896 4.70489 224.701 6.38713L223.44 9.35518L223.951 14.7398L226.535 9.89431C227.383 8.30455 230.237 5.50097 231.886 4.77396L234.509 3.61699C235.389 3.22872 236.291 4.1184 235.914 5.00367L235.499 5.97776C235.192 6.69669 234.701 7.32119 234.074 7.78728C232.266 9.13078 229.45 12.574 228.824 14.7376L227.683 18.6766L230.107 16.129C231.516 14.6488 235.733 10.9312 237.596 10.0908L238.031 9.89431C238.7 9.59238 239.439 10.1497 239.332 10.8759L239.287 11.1706C239.166 12.0013 238.752 12.7619 238.122 13.3169C237.446 13.9125 231.886 17.8714 231.297 22.361L237.67 18.8556C238.231 18.5474 238.931 18.8531 239.086 19.4736C239.35 20.5309 238.919 21.6393 238.03 22.2714C235.755 23.8914 231.705 26.9933 231.886 28.4316C232.349 32.1266 231.327 35.0815 227.683 36.9522L207.271 76.5569C201.565 87.6274 191.77 96.0401 179.964 100.01L174.653 101.795L173.172 80.1261L182.554 76.0937L217.161 30.9678Z",
    fill: "url(#paint6_linear_2770_43146)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M229.784 14.2144L222.102 17.5301L217.875 30.6649L224.14 31.1436C226.146 30.8433 230.168 32.2863 230.401 30.2063C230.693 27.6063 221.39 22.4321 227.18 20.2865C229.778 19.3239 231.252 17.6672 232.039 16.0896C232.747 14.6683 231.242 13.5849 229.784 14.2144Z",
    fill: "url(#paint7_linear_2770_43146)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M218.578 29.0922L221.018 20.1437C221.598 18.0171 223.19 16.3131 225.271 15.589L230.193 13.8773C230.411 13.8012 230.654 13.8569 230.817 14.0206V14.0206C231.819 15.0214 231.605 16.6977 230.385 17.4153L226.435 19.739C227.058 22.2332 227.931 27.895 226.435 30.5887",
    stroke: "black",
    strokeWidth: 0.748261
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M148.078 126.944C149.191 107.762 142.622 84.9126 139.104 75.5234C158.156 81.7011 171.977 79.3306 178.505 76.699L180.604 103.622L154.874 113.146C157.472 130.262 159.154 146.845 152.648 174.887C150.703 183.269 147.809 185.843 137.661 186.983C127.513 188.123 146.688 150.921 148.078 126.944Z",
    fill: "url(#paint8_linear_2770_43146)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M115.41 138.177L136.474 107.332C136.917 106.683 137.788 106.488 138.466 106.885L161.226 120.222C161.986 120.667 162.199 121.669 161.686 122.385L139.879 152.795C139.429 153.424 138.574 153.606 137.907 153.214L115.888 140.313C115.14 139.874 114.92 138.893 115.41 138.177Z",
    fill: "#2C2770"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.911 122.595L81.4383 120.523L63.096 111.43L57.6007 126.482C55.1626 133.159 60.4781 140.112 67.5617 139.51L111.671 135.762L116.726 137.381C116.875 137.429 117.028 137.465 117.184 137.489L123.875 138.518C123.932 138.527 123.989 138.541 124.045 138.559L133.387 141.628C134.162 141.882 135.003 141.51 135.335 140.765C135.692 139.964 135.332 139.025 134.531 138.668L127.421 135.499L136.475 137.488C137.148 137.635 137.821 137.236 138.015 136.574C138.206 135.916 137.858 135.221 137.216 134.98L129.02 131.909L138.795 132.781C139.572 132.85 140.276 132.32 140.424 131.554C140.575 130.769 140.093 130.001 139.32 129.795L129.256 127.121L139.727 127.843C140.746 127.913 141.587 127.058 141.5 126.039C141.437 125.301 140.892 124.693 140.165 124.548L126.865 121.913L129.987 117.491L121.186 117.835C120.168 117.874 119.177 118.173 118.307 118.703L111.911 122.595Z",
    fill: "url(#paint9_linear_2770_43146)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M361.828 494.29L372.227 489.083C377.759 486.312 379.862 474.163 379.862 474.163L392.281 476.556L388.978 489.803L389.231 497.253L362.491 495.863L361.828 494.29Z",
    fill: "url(#paint10_linear_2770_43146)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M400.711 564.134L411.11 558.927C416.642 556.156 418.744 544.006 418.744 544.006L431.164 546.399L427.861 559.647L428.114 567.097L401.374 565.707L400.711 564.134Z",
    fill: "url(#paint11_linear_2770_43146)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M364.28 495.441L388.317 495.265C389.867 497.562 389.859 500.574 388.296 502.863L385.344 507.187L375.574 505.455L375.49 502.971L370.139 503.586C367.93 503.84 365.694 503.695 363.536 503.157L355.901 501.253C354.856 500.993 354.028 500.196 353.727 499.163C353.262 497.567 354.17 495.895 355.762 495.416L366.957 492.05L363.856 493.304C363.225 493.559 362.971 494.319 363.322 494.903C363.524 495.239 363.888 495.444 364.28 495.441Z",
    fill: "#2C2770"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M403.163 565.285L427.199 565.108C428.75 567.406 428.742 570.418 427.179 572.707L424.227 577.031L414.457 575.299L414.373 572.815L409.022 573.43C406.813 573.684 404.577 573.539 402.419 573.001L394.784 571.097C393.739 570.837 392.911 570.04 392.61 569.006C392.144 567.411 393.053 565.738 394.644 565.259L405.84 561.893L402.739 563.148C402.107 563.403 401.853 564.162 402.205 564.747C402.406 565.083 402.771 565.287 403.163 565.285Z",
    fill: "#2C2770"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M415.86 548.372L433.285 552.717L462.961 468.308L502.297 419.226C512.239 406.819 517.972 391.568 518.663 375.684L518.741 373.905L471.845 353.192L435.07 365.416C419.782 370.498 407.804 382.521 402.778 397.827L375.982 479.435L391.141 488.227L433.734 400.909L470.57 393.899L445.48 433.879C441.313 440.518 438.311 447.82 436.603 455.47L415.86 548.372Z",
    fill: "url(#paint12_linear_2770_43146)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M514.578 384.432L459.64 464.045L432.294 555.166",
    stroke: "white",
    strokeWidth: 0.748261
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M469.481 395.163L433.638 393.552L390.415 488.04",
    stroke: "white",
    strokeWidth: 0.748261
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M466.609 300.453L479.481 300.252L473.71 318.35L462.776 318.292C453.31 318.241 445.835 310.236 446.435 300.788L449.668 249.837L445.992 243.283L443.263 237.603C442.328 235.657 442.31 233.395 443.214 231.434C443.869 230.012 445.145 228.972 446.67 228.617L454.37 226.825L452.119 214.718C451.9 213.542 452.782 212.449 453.978 212.413C454.849 212.387 455.632 212.943 455.894 213.775L460.314 227.77L462.428 227.863C463.41 227.906 464.25 228.583 464.5 229.533L465.867 234.717C466.221 236.061 466.097 237.486 465.516 238.748L461.978 246.427L466.609 300.453Z",
    fill: "url(#paint13_linear_2770_43146)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M449.07 228.102L451.535 236.97C451.78 237.85 452.664 238.391 453.559 238.207V238.207C454.41 238.032 455.001 237.255 454.942 236.388L454.769 233.811",
    stroke: "black",
    strokeWidth: 0.748261
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M444.883 229.164L448.298 237.789C448.619 238.601 449.515 239.025 450.347 238.76V238.76C451.193 238.49 451.677 237.602 451.445 236.744L451.329 236.313",
    stroke: "black",
    strokeWidth: 0.748261
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M443.008 234.82L445.873 241.413C446.236 242.249 447.173 242.674 448.042 242.397V242.397C448.881 242.129 449.398 241.287 449.255 240.417L448.911 238.319",
    stroke: "black",
    strokeWidth: 0.748261
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M458.78 228.088L451.055 229.595C450.405 229.722 449.964 230.331 450.047 230.989V230.989C450.228 232.411 451.345 233.531 452.767 233.715L459.359 234.567C457.931 235.112 455.266 239.236 454.104 243.849",
    stroke: "black",
    strokeWidth: 0.748261
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M554.752 321.122L549.797 316.619L530.095 304.515C520.007 298.316 508.116 295.72 496.362 297.147L473.957 299.868L471.52 320.467L490.576 321.363L488.308 324.304C484.962 328.645 485.041 334.717 488.5 338.967L472.01 353.727C469.024 356.399 469.456 361.193 472.871 363.289L513.33 388.12C516.778 390.237 521.29 388.393 522.269 384.466L526.9 365.893L539.516 357.856L538.67 376.649L557.715 383.406L563.296 344.925C564.581 336.064 561.379 327.143 554.752 321.122Z",
    fill: "#1BE3B3"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M563.142 328.549L552.128 314.346L523.78 300.55C515.738 296.636 506.829 294.847 497.9 295.351L473.701 296.721L470.066 321.648L490.636 319.563L488.497 338.968L472.078 353.663C469.071 356.355 469.533 361.189 472.996 363.26L513.542 387.521C516.99 389.585 521.452 387.732 522.424 383.833L526.897 365.893L539.777 357.537L538.667 376.649L557.711 383.406L567.473 353.387C570.233 344.901 568.61 335.6 563.142 328.549Z",
    fill: "url(#paint14_linear_2770_43146)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2770_43146",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 470,
    y: 295,
    width: 99,
    height: 94
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M563.142 328.549L552.128 314.346L523.78 300.55C515.738 296.636 506.829 294.847 497.9 295.351L473.701 296.721L470.066 321.648L490.636 319.563L488.497 338.968L472.078 353.663C469.071 356.355 469.533 361.189 472.996 363.26L513.542 387.521C516.99 389.585 521.452 387.732 522.424 383.833L526.897 365.893L539.777 357.537L538.667 376.649L557.711 383.406L567.473 353.387C570.233 344.901 568.61 335.6 563.142 328.549Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2770_43146)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M570.03 278.245C571.727 271.687 566.035 268.376 562.977 267.54C561.737 265.918 560.031 260.723 552.809 258.989C545.588 257.256 536.228 258.065 534.697 267.626C534.697 267.626 526.351 283.897 538.846 288.851C537.291 292.773 539.157 316.565 543.883 304.644C548.609 292.722 543.378 301.039 554.87 295.204C560.429 295.395 567.91 286.443 570.03 278.245Z",
    fill: "url(#paint15_linear_2770_43146)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 568.896,
    cy: 257.809,
    r: 12.3463,
    transform: "rotate(21.6268 568.896 257.809)",
    fill: "url(#paint16_linear_2770_43146)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M562.44 283.141L561.279 286.07C562.709 286.261 565.339 287.228 564.41 289.571C563.249 292.5 560.522 293.679 558.957 291.928C557.496 294.871 553.478 300.229 547.617 300.803C546.882 303.167 546.086 306.663 546.333 309.52C546.657 313.263 549.083 315.882 550.256 316.723C547.4 318.228 540.126 320.616 533.877 318.139C527.629 315.661 524.618 309.195 523.894 306.272C525 306.334 528.029 306.104 531.301 304.689C533.877 303.576 535.968 299.33 537.149 296.082C534.173 291.744 535.106 285.779 535.524 282.638C534.094 282.447 531.542 281.285 532.78 278.161C534.019 275.036 536.999 276.067 537.847 276.78L539.008 273.851C540.832 274.951 545.96 276.833 551.886 275.567C557.811 274.301 559.55 273.333 559.679 273.008C559.034 274.635 558.564 277.915 559.309 279.64C560.488 282.367 561.918 282.558 562.44 283.141Z",
    fill: "#FFAE64"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M562.44 283.141L561.279 286.07C562.709 286.261 565.339 287.228 564.41 289.571C563.249 292.5 560.522 293.679 558.957 291.928C557.496 294.871 553.478 300.229 547.617 300.803C546.882 303.167 546.086 306.663 546.333 309.52C546.657 313.263 549.083 315.882 550.256 316.723C547.4 318.228 540.126 320.616 533.877 318.139C527.629 315.661 524.618 309.195 523.894 306.272C525 306.334 528.029 306.104 531.301 304.689C533.877 303.576 535.968 299.33 537.149 296.082C534.173 291.744 535.106 285.779 535.524 282.638C534.094 282.447 531.542 281.285 532.78 278.161C534.019 275.036 536.999 276.067 537.847 276.78L539.008 273.851C540.832 274.951 545.96 276.833 551.886 275.567C557.811 274.301 559.55 273.333 559.679 273.008C559.034 274.635 558.564 277.915 559.309 279.64C560.488 282.367 561.918 282.558 562.44 283.141Z",
    fill: "url(#paint17_linear_2770_43146)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M548.965 293.269L543.643 293.729C543.709 294.49 544.397 295.717 546.121 295.813C547.845 295.909 548.652 294.369 548.965 293.269Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 540.609,
    y: 274.531,
    width: 5.46116,
    height: 2.04793,
    rx: 1.02397,
    transform: "rotate(21.6268 540.609 274.531)",
    fill: "#2C2770"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 553.297,
    y: 279.562,
    width: 5.46116,
    height: 2.04793,
    rx: 1.02397,
    transform: "rotate(21.6268 553.297 279.562)",
    fill: "#2C2770"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 553.887,
    cy: 284.571,
    r: 1.02397,
    transform: "rotate(21.6268 553.887 284.571)",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M547.723 278.817L543.194 290.239L546.05 291.371",
    stroke: "black",
    strokeWidth: 0.748261
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 541.824,
    cy: 279.79,
    r: 1.02397,
    transform: "rotate(21.6268 541.824 279.79)",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M562.204 288.602C562.228 289.469 561.678 291.038 559.294 290.386",
    stroke: "black",
    strokeWidth: 0.748261
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M535.073 277.846C534.462 278.461 533.787 279.98 535.97 281.139",
    stroke: "black",
    strokeWidth: 0.748261
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M536.423 295.273C537.059 296.137 539.222 298.585 542.015 299.692C544.665 300.743 547.484 300.868 548.414 300.822L548.546 300.813C548.507 300.817 548.463 300.82 548.414 300.822L533.464 301.81L536.423 295.273Z",
    fill: "#FF8282"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M504.317 380.701L472.566 393.606L425.635 363.782L459.744 350.694L504.317 380.701Z",
    fill: "#DAE2FF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M502.863 378.794L472.02 391.155L424.181 361.876L458.291 348.788L502.863 378.794Z",
    fill: "#6B8CFF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M430.316 318.293L477.901 346.8C479.071 347.502 479.767 348.785 479.716 350.149L478.19 391.15L473.473 393.058L428.268 365.915C427.171 365.256 426.487 364.082 426.454 362.803L425.334 318.591L430.316 318.293Z",
    fill: "#DAE2FF"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M509.829 369.068L538.578 379.36L539.39 376.104L556.011 380.582L555.478 384.379C554.244 393.167 544.999 398.381 536.841 394.89L505.793 381.603L500.487 381.499C500.33 381.496 500.173 381.48 500.019 381.452L493.355 380.26C493.297 380.25 493.239 380.244 493.18 380.243L483.347 380.123C482.532 380.113 481.857 379.488 481.784 378.676C481.705 377.802 482.35 377.03 483.224 376.952L490.977 376.255L481.767 375.206C481.081 375.127 480.574 374.532 480.606 373.843C480.638 373.158 481.191 372.613 481.877 372.593L490.626 372.341L481.095 370.001C480.337 369.815 479.844 369.086 479.952 368.313C480.062 367.521 480.767 366.95 481.564 367.006L491.952 367.735L481.802 365.025C480.821 364.763 480.305 363.687 480.714 362.757C481.015 362.074 481.735 361.678 482.473 361.787L498.041 364.099L496.149 362.536C495.218 361.768 494.624 360.665 494.495 359.465C494.442 358.973 494.928 358.599 495.39 358.778L502.595 361.561C503.545 361.928 504.386 362.532 505.038 363.314L509.829 369.068Z",
    fill: "url(#paint18_linear_2770_43146)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M426.454 318.806L475.063 347.941C476.237 348.644 476.932 349.931 476.879 351.297L475.347 390.171C475.236 393.002 472.142 394.686 469.704 393.244L425.534 367.101C424.383 366.42 423.683 365.177 423.698 363.84L424.188 320.073C424.201 318.918 425.463 318.212 426.454 318.806Z",
    fill: "#6B8CFF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.39346,
    cy: 4.85412,
    rx: 5.39346,
    ry: 4.85412,
    transform: "matrix(-0.500392 -0.865799 -0.865799 0.500392 455.82 359)",
    fill: "#DAE2FF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.2085,
    cy: 12.2085,
    r: 12.2085,
    transform: "matrix(0.982324 -0.18719 -0.18719 -0.982324 251.383 502.445)",
    fill: "#54B7FF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.9907,
    cy: 20.9907,
    r: 20.9907,
    transform: "matrix(0.982324 -0.18719 -0.18719 -0.982324 228.492 497.727)",
    stroke: "#7268F5",
    strokeWidth: 0.748261
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M227.469 166.993L189.673 245.829C163.904 299.579 169.054 363.038 203.154 411.929L222.725 421.312C293.779 423.351 359.371 383.359 390.1 319.263L419.064 258.848L408.016 253.552C374.212 237.345 350.279 205.852 343.718 168.942L324.147 159.559C304.431 181.923 272.258 188.465 245.374 175.577L227.469 166.993Z",
    fill: "#299067"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M206.563 157.399L177.148 218.754C146.671 282.324 156.329 357.86 201.819 411.718C272.873 413.758 338.465 373.766 369.194 309.669L398.158 249.255L387.111 243.958C353.306 227.751 329.373 196.258 322.812 159.348C289.568 177.21 249.793 178.125 215.763 161.81L206.563 157.399Z",
    fill: "url(#paint19_linear_2770_43146)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.676 184.215L193.122 233.343C168.561 284.575 176.379 345.453 213.087 388.817C270.348 390.522 323.233 358.317 347.998 306.661L371.188 258.292L362.194 253.98C334.98 240.933 315.698 215.597 310.375 185.89C283.592 200.233 251.575 200.947 224.179 187.812L216.676 184.215Z",
    stroke: "#0C6C46",
    strokeWidth: 4.46724
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2770_43146)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.149 280.693C301.191 268.835 296.476 254.325 284.618 248.283C272.761 242.242 258.251 246.956 252.209 258.814C248.396 266.256 248.794 275.159 253.257 282.232L234.092 304.917C232.392 306.939 231.706 309.625 232.228 312.215C232.751 314.805 234.425 317.015 236.776 318.22L256.16 328.096C258.52 329.298 261.301 329.356 263.709 328.252C266.117 327.149 267.889 325.006 268.521 322.433L275.608 293.594C283.942 293.044 291.369 288.14 295.149 280.693Z",
    fill: "#0C6C46"
  }))), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.606 251.041C16.4176 260.03 14.8908 270.671 17.3428 280.756C19.795 290.84 26.0373 299.593 34.7736 305.196C43.5098 310.799 54.0686 312.821 64.2569 310.843C69.6621 309.793 74.7426 307.66 79.2182 304.625L181.424 392.381C185.137 395.569 190.728 395.143 193.916 391.433L194.132 391.177C197.321 387.467 196.895 381.875 193.185 378.689L187.576 373.874L193.548 366.919C196.734 363.207 196.311 357.617 192.598 354.429L192.344 354.212C188.631 351.024 183.041 351.45 179.854 355.161L173.883 362.116L167.43 356.576L180.364 341.511C183.551 337.8 183.126 332.208 179.414 329.021L179.16 328.803C175.449 325.617 169.857 326.042 166.67 329.753L153.736 344.818L91.5202 291.398C96.0413 283.567 97.8199 274.405 96.5025 265.385C95.0024 255.116 89.604 245.819 81.4288 239.425C73.2536 233.031 62.9296 230.033 52.6012 231.051C42.2727 232.07 32.7338 237.028 25.9651 244.896C24.3238 246.804 22.8642 248.861 21.606 251.041ZM39.5228 261.371C40.1398 260.308 40.8537 259.304 41.656 258.372C44.8438 254.666 49.2986 252.281 54.1506 251.683C59.0024 251.085 63.9031 252.318 67.895 255.14C71.8869 257.962 74.6834 262.171 75.7383 266.944C76.7931 271.718 76.0304 276.713 73.5994 280.954C72.9808 282.022 72.2645 283.029 71.4596 283.965C68.2718 287.671 63.8166 290.057 58.9643 290.654C54.1122 291.252 49.2114 290.019 45.2193 287.196C41.2276 284.374 38.4311 280.164 37.3769 275.391C36.3227 270.617 37.086 265.621 39.5179 261.38L39.5228 261.371Z",
    fill: "url(#paint20_linear_2770_43146)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2770_43146",
    x: 232.055,
    y: 245.648,
    width: 68.7266,
    height: 88.3906,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2770_43146"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2770_43146",
    x1: 16.4609,
    y1: 137.555,
    x2: 16.4609,
    y2: 328.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A65A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2770_43146",
    x1: 47.9453,
    y1: 215.508,
    x2: 47.9453,
    y2: 252.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A65A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2770_43146",
    x1: 100.25,
    y1: 18.0781,
    x2: 100.25,
    y2: 61.9202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A65A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2770_43146",
    x1: 111.25,
    y1: 47.5625,
    x2: 111.25,
    y2: 87.0697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9D9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B1AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2770_43146",
    x1: 112.758,
    y1: 33.25,
    x2: 112.758,
    y2: 68.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9D9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B1AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2770_43146",
    x1: 62.4922,
    y1: 70.0234,
    x2: 62.4922,
    y2: 188.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ABBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B86DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2770_43146",
    x1: 173.172,
    y1: 0,
    x2: 173.172,
    y2: 101.795,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9D9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B1AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2770_43146",
    x1: 217.875,
    y1: 14.0312,
    x2: 217.875,
    y2: 31.3543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9D9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B1AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2770_43146",
    x1: 134.711,
    y1: 75.5234,
    x2: 134.711,
    y2: 187.008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1ABBF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B86DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2770_43146",
    x1: 57,
    y1: 111.43,
    x2: 57,
    y2: 141.708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9D9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B1AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2770_43146",
    x1: 367.773,
    y1: 470.445,
    x2: 361.498,
    y2: 495.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9D9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B1AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2770_43146",
    x1: 406.656,
    y1: 540.289,
    x2: 400.381,
    y2: 565.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9D9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B1AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2770_43146",
    x1: 411.227,
    y1: 338.078,
    x2: 362.134,
    y2: 534.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A65A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2770_43146",
    x1: 448.203,
    y1: 210.898,
    x2: 423.733,
    y2: 309.044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9D9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B1AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2770_43146",
    x1: 414.507,
    y1: 317.617,
    x2: 473.929,
    y2: 438.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCFAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB7932"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2770_43146",
    x1: 537.188,
    y1: 255.094,
    x2: 525.021,
    y2: 303.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A65A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2770_43146",
    x1: 556.549,
    y1: 245.462,
    x2: 556.549,
    y2: 270.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A65A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2770_43146",
    x1: 533.797,
    y1: 266.555,
    x2: 521.663,
    y2: 315.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9D9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B1AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2770_43146",
    x1: 482.484,
    y1: 355.555,
    x2: 476.39,
    y2: 379.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9D9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B1AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2770_43146",
    x1: 234.781,
    y1: 108.523,
    x2: 95.2535,
    y2: 350.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80D9B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09CD7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2770_43146",
    x1: 0.28125,
    y1: 287.977,
    x2: 190.491,
    y2: 397.794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBA5F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstTimePassword);
export default __webpack_public_path__ + "static/media/firstTimePassword.d6882ef31bc5248243b9faddb04cc79a.svg";
export { ForwardRef as ReactComponent };